"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IncomeTaxBand_1 = require("./IncomeTaxBand");
var IndexedDollarParameter_1 = require("./IndexedDollarParameter");
var LinearScale_1 = require("./LinearScale");
var AdvDate_1 = require("./../lib/AdvDate");
var _01_07_1952 = new AdvDate_1.AdvDate("01/07/1952");
var _01_07_1955 = new AdvDate_1.AdvDate("01/07/1955");
var _01_07_1935 = new AdvDate_1.AdvDate("01/07/1935");
var _01_07_1938 = new AdvDate_1.AdvDate("01/07/1938");
var _01_07_1941 = new AdvDate_1.AdvDate("01/07/1941");
var _01_07_1944 = new AdvDate_1.AdvDate("01/07/1944");
var _01_07_1947 = new AdvDate_1.AdvDate("01/07/1947");
var _01_07_2022 = new AdvDate_1.AdvDate("01/07/2022");
var _01_07_2024 = new AdvDate_1.AdvDate("01/07/2024");
var _01_07_2025 = new AdvDate_1.AdvDate("01/07/2025");
var PAYGIncomeTaxBasis = (function () {
    function PAYGIncomeTaxBasis() {
        this._incomeTaxBands = [];
        this._countIncomeTaxBands = 0;
        this._medicareLowerThreshold = null;
        this._medicareUpperThreshold = null;
        this._medicareRate = 0;
        this._medicarePhasingInRate = 0;
        this._maximumSato = null;
        this._satoIncomeTest = null;
        this._incomeTaxScheme = null;
        this._incomeTaxScheme_2022 = null;
        this._incomeTaxScheme_2024 = null;
        this._LITO_2022_LowIncomeThreshold = null;
        this._LITO_2022_MiddleIncomeThreshold = null;
        this._LITO_2022_HighIncomeThreshold = null;
        this._LITO_2022_MaxPaymentRate = null;
        this._LITO_2022_LowPaymentRate = null;
        this._LITO_2022_InitialPhaseOutRate = 0;
        this._LITO_2022_SubsequentPhaseOutRate = 0;
        this._dateProjectionRun = null;
        this._dateStartCurrentProjectionYear = null;
        this._yearCount = 0;
    }
    PAYGIncomeTaxBasis.prototype.initialise = function (p, isMarried, wageIndexation) {
        var inputCounter;
        var taxToStartBand;
        this._medicareLowerThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._medicareUpperThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._maximumSato = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._satoIncomeTest = new LinearScale_1.LinearScale();
        this._LITO_2022_LowIncomeThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._LITO_2022_MiddleIncomeThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._LITO_2022_HighIncomeThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._LITO_2022_MaxPaymentRate = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._LITO_2022_LowPaymentRate = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._medicareLowerThreshold.initialise(p.getParamNumber("MedicareLowerThreshold"), wageIndexation);
        this._medicareUpperThreshold.initialise(p.getParamNumber("MedicareUpperThreshold"), wageIndexation);
        this._medicareRate = p.getParamNumber("MedicareRate");
        this._medicarePhasingInRate = p.getParamNumber("MedicarePhasingInRate");
        this._LITO_2022_LowIncomeThreshold.initialise(p.getParamNumber('LITO_2022_LowIncomeThreshold'), wageIndexation);
        this._LITO_2022_MiddleIncomeThreshold.initialise(p.getParamNumber('LITO_2022_MiddleIncomeThreshold'), wageIndexation);
        this._LITO_2022_HighIncomeThreshold.initialise(p.getParamNumber('LITO_2022_HighIncomeThreshold'), wageIndexation);
        this._LITO_2022_MaxPaymentRate.initialise(p.getParamNumber('LITO_2022_MaxPaymentRate'), wageIndexation);
        this._LITO_2022_LowPaymentRate.initialise(p.getParamNumber('LITO_2022_LowPaymentRate'), wageIndexation);
        this._LITO_2022_InitialPhaseOutRate = p.getParamNumber('LITO_2022_InitialPhaseOutRate');
        this._LITO_2022_SubsequentPhaseOutRate = p.getParamNumber('LITO_2022_SubsequentPhaseOutRate');
        if (isMarried) {
            this._maximumSato.initialise(p.getParamNumber("MaximumSATOCouple"), wageIndexation);
            this._satoIncomeTest.initialise(p.getParamNumber("SATOLowerThresholdCouple"), p.getParamNumber("SATOUpperThresholdCouple"), wageIndexation);
        }
        else {
            this._maximumSato.initialise(p.getParamNumber("MaximumSATO"), wageIndexation);
            this._satoIncomeTest.initialise(p.getParamNumber("SATOLowerThreshold"), p.getParamNumber("SATOUpperThreshold"), wageIndexation);
        }
        this._incomeTaxScheme = p.getParamObject("IncomeTaxRates_2024");
        this._countIncomeTaxBands = this._incomeTaxScheme.numberOfBands;
        for (inputCounter = 0; inputCounter < this._countIncomeTaxBands; inputCounter++) {
            this._incomeTaxBands[inputCounter] = new IncomeTaxBand_1.IncomeTaxBand();
            this._incomeTaxBands[inputCounter].setStartBand(this._incomeTaxScheme.bandStartAtIndex(inputCounter + 1), wageIndexation);
            this._incomeTaxBands[inputCounter].setRateInBand(this._incomeTaxScheme.rateAtIndex(inputCounter + 1));
        }
        taxToStartBand = 0;
        for (inputCounter = 0; inputCounter < this._countIncomeTaxBands; inputCounter++) {
            if (inputCounter === 0) {
                this._incomeTaxBands[inputCounter].setTaxToStartOfBand(0);
            }
            else {
                taxToStartBand = taxToStartBand +
                    ((this._incomeTaxBands[inputCounter].startOfTaxBand -
                        this._incomeTaxBands[inputCounter - 1].startOfTaxBand) *
                        this._incomeTaxBands[inputCounter - 1].taxRateInBand);
                this._incomeTaxBands[inputCounter].setTaxToStartOfBand(taxToStartBand);
            }
        }
        this._dateProjectionRun = new AdvDate_1.AdvDate();
        this._dateStartCurrentProjectionYear = new AdvDate_1.AdvDate();
        this._yearCount = 1;
    };
    PAYGIncomeTaxBasis.prototype.annualUpdate = function (yearCount, wageIndexation) {
        var taxToStartBand;
        var inputCounter;
        this._dateStartCurrentProjectionYear = this._dateStartCurrentProjectionYear.plus(1);
        this._medicareLowerThreshold.index(yearCount);
        this._medicareUpperThreshold.index(yearCount);
        this._maximumSato.index(yearCount);
        this._satoIncomeTest.index(yearCount);
        if (this._dateStartCurrentProjectionYear.afterOrOn(_01_07_2025)) {
            this._LITO_2022_LowIncomeThreshold.index(yearCount);
            this._LITO_2022_MiddleIncomeThreshold.index(yearCount);
            this._LITO_2022_HighIncomeThreshold.index(yearCount);
            this._LITO_2022_MaxPaymentRate.index(yearCount);
            this._LITO_2022_LowPaymentRate.index(yearCount);
            for (inputCounter = 0; inputCounter < this._countIncomeTaxBands; inputCounter++) {
                this._incomeTaxBands[inputCounter].index(yearCount);
            }
        }
        taxToStartBand = 0;
        for (inputCounter = 1; inputCounter <= this._countIncomeTaxBands; inputCounter++) {
            if (inputCounter === 1) {
                this._incomeTaxBands[inputCounter - 1].setTaxToStartOfBand(0);
            }
            else {
                taxToStartBand = taxToStartBand +
                    ((this._incomeTaxBands[inputCounter - 1].startOfTaxBand -
                        this._incomeTaxBands[inputCounter - 2].startOfTaxBand) *
                        this._incomeTaxBands[inputCounter - 2].taxRateInBand);
                this._incomeTaxBands[inputCounter - 1].setTaxToStartOfBand(taxToStartBand);
            }
        }
        this._yearCount = this._yearCount + 1;
    };
    PAYGIncomeTaxBasis.prototype.taxPayable = function (sex, dateBirth, age, income) {
        var tax = Math.max(0, (this.incomeTax(income) +
            this.medicare(income) -
            this.lowIncomeTaxOffset(income) -
            this.seniorAustralianTaxOffset(sex, dateBirth, age, income)));
        return tax;
    };
    PAYGIncomeTaxBasis.prototype.incomeTax = function (income) {
        var taxBandCounter;
        if (income <= 0) {
            return 0;
        }
        else {
            taxBandCounter = this._countIncomeTaxBands;
            while (this._incomeTaxBands[taxBandCounter - 1].startOfTaxBand > income) {
                taxBandCounter = taxBandCounter - 1;
            }
            return this._incomeTaxBands[taxBandCounter - 1].taxToStartOfBand +
                ((income - this._incomeTaxBands[taxBandCounter - 1].startOfTaxBand)) *
                    this._incomeTaxBands[taxBandCounter - 1].taxRateInBand;
        }
    };
    PAYGIncomeTaxBasis.prototype.medicare = function (income) {
        if (income < this._medicareLowerThreshold.value) {
            return 0;
        }
        else if (income > this._medicareUpperThreshold.value) {
            return income * this._medicareRate;
        }
        else {
            return (income - this._medicareLowerThreshold.value) * this._medicarePhasingInRate;
        }
    };
    PAYGIncomeTaxBasis.prototype.lowIncomeTaxOffset = function (income) {
        if (income <= this._LITO_2022_LowIncomeThreshold.value) {
            return this._LITO_2022_MaxPaymentRate.value;
        }
        else if (income <= this._LITO_2022_MiddleIncomeThreshold.value) {
            return this._LITO_2022_MaxPaymentRate.value - (income - this._LITO_2022_LowIncomeThreshold.value) * this._LITO_2022_InitialPhaseOutRate;
        }
        else if (income <= this._LITO_2022_HighIncomeThreshold.value) {
            return this._LITO_2022_LowPaymentRate.value - (income - this._LITO_2022_MiddleIncomeThreshold.value) * this._LITO_2022_SubsequentPhaseOutRate;
        }
        else {
            return 0;
        }
    };
    PAYGIncomeTaxBasis.prototype.seniorAustralianTaxOffset = function (sex, dateBirth, age, income) {
        if (this.isQualifyingAgeForSeniorAustralianTaxOffset(sex, dateBirth, age)) {
            return this._maximumSato.value * this._satoIncomeTest.getProportion(income);
        }
        else {
            return 0;
        }
    };
    PAYGIncomeTaxBasis.prototype.isQualifyingAgeForSeniorAustralianTaxOffset = function (sex, dateBirth, age) {
        var qualifyingAge = 0;
        if (sex === "Male") {
            if (dateBirth.before(_01_07_1952)) {
                qualifyingAge = 65;
            }
            else if (dateBirth.before(_01_07_1955)) {
                qualifyingAge = 66;
            }
            else {
                qualifyingAge = 67;
            }
        }
        else {
            if (dateBirth.before(_01_07_1935)) {
                qualifyingAge = 60;
            }
            else if (dateBirth.before(_01_07_1938)) {
                qualifyingAge = 61;
            }
            else if (dateBirth.before(_01_07_1941)) {
                qualifyingAge = 62;
            }
            else if (dateBirth.before(_01_07_1944)) {
                qualifyingAge = 63;
            }
            else if (dateBirth.before(_01_07_1947)) {
                qualifyingAge = 64;
            }
            else if (dateBirth.before(_01_07_1952)) {
                qualifyingAge = 65;
            }
            else if (dateBirth.before(_01_07_1952)) {
                qualifyingAge = 65;
            }
            else if (dateBirth.before(_01_07_1955)) {
                qualifyingAge = 66;
            }
            else {
                qualifyingAge = 67;
            }
        }
        if (age >= qualifyingAge) {
            return true;
        }
        else {
            return false;
        }
    };
    PAYGIncomeTaxBasis.prototype.getcountIncomeTaxBands = function () {
        return this._countIncomeTaxBands;
    };
    PAYGIncomeTaxBasis.prototype.startTaxBand = function (taxBandNumber) {
        return this._incomeTaxBands[taxBandNumber].startOfTaxBand;
    };
    PAYGIncomeTaxBasis.prototype.taxRateInBand = function (taxBandNumber) {
        return this._incomeTaxBands[taxBandNumber].taxRateInBand;
    };
    PAYGIncomeTaxBasis.prototype.taxToStartOfTaxBand = function (taxBandNumber) {
        return this._incomeTaxBands[taxBandNumber].taxToStartOfBand;
    };
    Object.defineProperty(PAYGIncomeTaxBasis.prototype, "medicareLowThreshold", {
        get: function () {
            return this._medicareLowerThreshold.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PAYGIncomeTaxBasis.prototype, "medicareUpperThreshold", {
        get: function () {
            return this._medicareUpperThreshold.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PAYGIncomeTaxBasis.prototype, "medicareRate", {
        get: function () {
            return this._medicareRate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PAYGIncomeTaxBasis.prototype, "medicarePhasingInRate", {
        get: function () {
            return this._medicarePhasingInRate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PAYGIncomeTaxBasis.prototype, "satoLowerThreshold", {
        get: function () {
            return this._satoIncomeTest.minimumThreshold;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PAYGIncomeTaxBasis.prototype, "satoUpperThreshold", {
        get: function () {
            return this._satoIncomeTest.maximumThreshold;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PAYGIncomeTaxBasis.prototype, "satoMaximumPayment", {
        get: function () {
            return this._maximumSato.value;
        },
        enumerable: true,
        configurable: true
    });
    return PAYGIncomeTaxBasis;
}());
exports.PAYGIncomeTaxBasis = PAYGIncomeTaxBasis;
//# sourceMappingURL=PAYGIncomeTaxBasis.js.map